import React, {useEffect, useState} from 'react';
import {CButton, CCol, CContainer, CForm, CFormInput, CRow} from "@coreui/react-pro";
// import DummyImage from '../../assets/images/dummy-profile-pic.png';
// import VerticalDots from '../../assets/icons/vertical-dots.svg';
// import ToggleIcon from '../../assets/icons/toggle.svg';
// import TransferIcon from '../../assets/icons/transfer.svg';
// import {BiLeftArrow, BiRightArrow} from "react-icons/bi";
import {useGetKPITrainers} from "../../hooks/admin/adminApiHooks";
import TrainerDashboard from "../../employer/pages/TrainerDashboard";
import KPIDashboard from "../../employer/pages/KPIDashboard";
import ShowLoading from "../../components/ShowLoading";

const KPIManager = () => {
    const [page, setPage] = useState(1)
    const [limit, setLimit] = useState(10)
    const [isTrainersView, setIsTrainersView] = useState(true);
    const {data, isLoading, refetch} = useGetKPITrainers(page, limit)

    useEffect(() => {
        refetch()
    }, [page, limit]);

    if (isLoading) {
        return <ShowLoading/>
    }

    return <CContainer>
        <CRow>
            <CCol md={12}
                  className="d-flex flex-column justify-content-center text-white border-radius-12 px-5 kpi-banner">
                <h3>Welcome to your KPI Manager</h3>
                <p>This is where you can add trainers, assign KPI’s, and view list of all trainers and KPI’s added</p>
            </CCol>
        </CRow>
        <CRow className="py-5">
            <CCol md={8}>
                <button
                    className={`btn ${isTrainersView ? 'btn-primary text-white' : 'btn-transparent text-primary'} px-4 py-2`}
                    onClick={() => setIsTrainersView(true)}>Trainers
                </button>
                <button
                    className={`btn ${!isTrainersView ? 'btn-primary text-white' : 'btn-transparent text-primary'} px-4 py-2 ms-2`}
                    onClick={() => setIsTrainersView(false)}>KPIs
                </button>
            </CCol>
            <CCol md={4}>
                <CForm>
                    <div
                        className="w-100 border-3 border-black border ps-2 rounded d-flex align-items-center">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                             className="bi bi-search" viewBox="0 0 16 16">
                            <path
                                d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"/>
                        </svg>
                        <CFormInput
                            type="search"
                            id="companyName"
                            placeholder="Search by names..."
                            autocomplete="off"
                            /*{...register('search')}*/
                            className="bg-transparent border rounded-0 border-white border-0 shadow-none"
                            // onChange={debouncedSearchChangeHandler}
                        />
                    </div>
                </CForm>
            </CCol>
        </CRow>
        <CContainer>
            {isTrainersView && <TrainerDashboard
                data={data}
                page={page}
                setPage={setPage}
                setLimit={setLimit}
            />}
            {!isTrainersView && <KPIDashboard data={data}/>}
        </CContainer>
    </CContainer>
}

export default KPIManager;